import Model from '@/models/Model'

export default class SlCustomer extends Model {

    static appends = ['branch_offices']
    
    resource() {
        return 'sl_customer'
    }
}